import { uploadImageBlob, uploadImageDataUrl } from '@/shared/spacesUpload'

export default {
  methods: {
    async getOptions() {
      const response = await this.$http.get(process.env.VUE_APP_API_URL + 'api/v1/options', {
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('z_token'),
        }
      })
      return response.body.json
    },
    uploadImageBlob,
    uploadImageDataUrl,
    async handleImageAdded (file, Editor, cursorLocation, resetUploader) {
      try {
        const cdnUrl = await uploadImageBlob(
          file,
          file.name || 'image.jpg',
          file.type || 'image/jpeg'
        )
        if (cdnUrl) {
          Editor.pasteHTML(cursorLocation, `<img src="${cdnUrl}">`)
        }
      } catch (error) {
        console.log(error)
      }
    },
    async converToBase64(file) {
      return new Promise((resolve, reject) => {
        var reader = new FileReader()
        reader.onload = ((theFile) => {
          return (e) => {
            var binaryData = e.target.result;
            //Converting Binary Data to base 64
            var base64String = window.btoa(binaryData);
            //showing file converted to base64
            resolve(base64String)
          }
        })(file)
        // Read in the image file as a data URL.
        reader.readAsBinaryString(file);
      })
    }
  }
}
